// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"ed9e9e9f","458":"1e9d52ce","508":"0451d069","774":"3285d004","787":"a76b2b62","819":"e73d49ae","858":"3ac04ff7","910":"892c71b0"}[chunkId] + ".chunk.js";
};